import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Socket, io } from 'socket.io-client';

import { apiConst } from '@/constants';

interface TestChatMessage {
  sender?: { id: string; username?: string };
  content: string;
}

export const ChatTest: React.FC = () => {
  const [projectId, setProjectId] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState<TestChatMessage[]>([]);
  const [userId, setUserId] = useState<string | null>(null);
  const socketRef = useRef<Socket | null>(null);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);

  const handleConnect = async () => {
    const token = localStorage.getItem('userToken');
    if (!token) {
      alert('JWT token not found');
      return;
    }

    if (!projectId.trim()) {
      alert('Please enter project ID');
      return;
    }

    const socket = io('http://localhost:4002', {
      auth: { token },
      transports: ['websocket'],
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      console.log('Connected to socket server');
      socket.emit('joinProjectRoom', { projectId });

      // Decode JWT to get userId (basic method)
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUserId(payload.userId);

      // Load old messages
      axios
        .get(`http://localhost:4002/chat/${projectId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setMessages(res.data);
        })
        .catch((err) => {
          console.error('Failed to load messages:', err);
        });
    });

    socket.on('receiveMessage', (data: TestChatMessage) => {
      setMessages((prev) => [...prev, data]);
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from socket server');
    });
  };

  const handleSend = () => {
    const trimmed = message.trim();
    if (!trimmed || !projectId) return;

    if (!socketRef.current || !socketRef.current.connected) {
      alert('Not connected to socket');
      return;
    }

    socketRef.current.emit(`${apiConst.sendMessage}`, {
      content: trimmed,
      projectId,
    });

    setMessage('');
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: 'auto', padding: 20 }}>
      <h2>💬 Project Chat</h2>

      <input
        placeholder="Enter Project ID"
        value={projectId}
        onChange={(e) => setProjectId(e.target.value)}
        style={{ marginRight: 10 }}
      />
      <button onClick={handleConnect}>Connect to Chat</button>

      <hr />

      <div
        style={{
          border: '1px solid #ccc',
          padding: 10,
          height: 400,
          overflowY: 'scroll',
          backgroundColor: '#f1f1f1',
        }}
      >
        {messages.map((msg, idx) => {
          const isMine = msg.sender?.id === userId;
          return (
            <div
              key={idx}
              style={{
                display: 'flex',
                justifyContent: isMine ? 'flex-end' : 'flex-start',
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  maxWidth: '60%',
                  padding: 10,
                  borderRadius: 12,
                  backgroundColor: isMine ? '#d1e7dd' : '#fff',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                {!isMine && (
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: 12,
                      color: '#555',
                      marginBottom: 4,
                    }}
                  >
                    {msg.sender?.username || msg.sender?.id}
                  </div>
                )}
                <div>{msg.content}</div>
              </div>
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>

      <div style={{ marginTop: 10 }}>
        <input
          placeholder="Type your message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSend()}
          style={{ width: '80%' }}
        />
        <button onClick={handleSend} style={{ width: '18%', marginLeft: '2%' }}>
          Send
        </button>
      </div>
    </div>
  );
};
